import { EVENT_NAME } from '../types'
import type { GraphStoreContext } from '../store'
import type { Node } from './node'
import type { Edge } from './edge'
import type { Graph } from './graph'

export enum StackAction {
  /**
   * 变更数据
   */
  changeData = 'changeData',
  /**
   * 显示 / 隐藏
   */
  visible = 'visible',
  /**
   * 添加节点
   */
  add = 'add',
  /**
   * 删除节点
   */
  delete = 'delete',
}

export class Stack<N extends Node = Node, E extends Edge = Edge> {
  /**
   * 图
   */
  graph: Graph<N, E>
  /**
   * 栈状态
   */
  state: Array<GraphStoreContext> = []
  /**
   * 游标
   */
  index = 0

  get canUndo() {
    return this.index > 0
  }

  get canRedo() {
    return this.index < this.state.length
  }

  constructor(graph: Graph<N, E>) {
    this.graph = graph
  }

  /**
   * 入栈一个状态
   *
   * @param data
   */
  push(data: GraphStoreContext): void {
    this.state.push(data)
  }

  /**
   * 回退
   */
  undo = () => {
    if (this.canUndo) {
      this.graph.emit(EVENT_NAME.undo)
    }
  }

  /**
   * 前进
   */
  redo = () => {
    if (this.canRedo) {
      this.graph.emit(EVENT_NAME.redo)
    }
  }
}
